export default {
  clientKey: process.env.SENTRY_CLIENT_KEY
}
